import React from 'react';
import './Spinner.css';

const Spinner = (props) => (
        <div style={{
                width: "100%",
                height: "100",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"}}
                >
        <div className= {props.isLogin ? "Loader Login-Loader": "Loader"} >Loading......</div></div>
);

export default Spinner;